<template>
    <div class="gallery-caption" :class="{ 'align-left': alignLeft }">
        <div class="media-caption">
            <div class="text-container" v-html="captionText || '&nbsp;'"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GalleryCaption",
    props: {
        caption: {
            type: String,
            default: ""
        },
        alignLeft: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        captionText() {
            if (!this.caption) return "";
            if (this.caption.includes("rel=\"noopener noreferrer nofollow\"")) {
                return this.caption;
            }
            return this.caption
                .replace("\n", "<br />")
                .replace("<a href=", "<a rel=\"noopener noreferrer nofollow\" href=");
        }
    }
}
</script>
